import axios from "axios";

const apiUrl = process.env.REACT_APP_API_URL;
const clientApiUrl = process.env.REACT_APP_CLIENT_API_URL;

const AssessmentResultsAPI = {
	getOrganizationAssessments: () => {
		return axios
			.get(`${apiUrl}/organizations/assessments`)
			.then((response) => response.data as OrganizationAssessmentsDTO[]);
	},
	getSession: (request: GetClientSiteSessionRequest) => {
		return axios
			.get(
				`${clientApiUrl}/datasets/${request.datasetId}/clients/${request.clientId}/session/${request.sessionId}`
			)
			.then((response) => response.data as AssessmentResultsDTO);
	},
	getAllAssessmentResults: () => {
		return axios
			.get(`${apiUrl}/assessment-results`)
			.then((response) => response.data as AssessmentResultsDTO[]);
	},
	// client site methods
	getClientSiteAssessmentResults: (
		request: GetClientSiteAssessmentResultsRequest
	) => {
		return axios
			.get(
				`${clientApiUrl}/datasets/${request.datasetId}/clients/${request.clientId}/assessment-results`
			)
			.then((response) => response.data as ClientSiteAssessmentResultsDTO[]);
	},

	getClientSiteAssessmentResultValues: (
		clientId: number,
		assessmentResultId: number,
		datasetId: number
	) => {
		return axios
			.get(
				`${clientApiUrl}/datasets/${datasetId}/clients/${clientId}/assessment-results/${assessmentResultId}`
			)
			.then((response) => response.data as CustomFieldValueDTO[]);
	},
	getDatasetAssessmentResults: (request: GetAllDatasetReportsRequest) => {
		return axios
			.get(`${clientApiUrl}/datasets/${request.datasetId}/reports`)
			.then((response) => response.data as ClientSiteAssessmentResultsDTO[]);
	},
	postAssessmentResultCustomFields: (
		request: AssessmentResultCustomFieldUpsertRequest
	) => {
		return axios
			.post(
				`${clientApiUrl}/datasets/${request.datasetId}/assessment-result/${request.assessmentResultId}`,
				request
			)
			.then((response) => response.data as CustomFieldValueDTO[]);
	},
	postAssessmentResultPurpose: (
		request: AssessmentResultPurposeUpsertRequest
	) => {
		return axios
			.post(
				`${clientApiUrl}/datasets/${request.datasetId}/assessment-result/${request.assessmentResultId}/purpose`,
				request
			)
			.then((response) => response.data as number);
	},
};

export default AssessmentResultsAPI;
